import * as TYPES from "./types";
import cloneDeep from 'lodash/cloneDeep';
import FLIGHT_COURSE_DEFAULT_STATE, {COURSE} from "./default-state";
import moment from "moment";
import legsErrorController from "./errors-controller";

export default function (state = cloneDeep(FLIGHT_COURSE_DEFAULT_STATE), action) {

    switch (action.type) {
        case TYPES.REFRESH:
            return {...state, refreshing: action.refreshing};
        case TYPES.SET_PAX_TYPE_WAS_CHANGED:
            return {...state, passengerTypeWasChanged: action.passengerTypeWasChanged};
        case TYPES.SET_ORIGIN:
            return {...state, origin: action.origin};
        case TYPES.SET_DESTINATION:
            return {...state, destination: action.destination};
        case TYPES.SET_IMAGINE_MODE:
            const paxTypeModifierImagine = {};
            if (action.imagineMode && state.passengerType !== 'ADULT') {
                paxTypeModifierImagine.passengerType = 'ADULT';
                paxTypeModifierImagine.passengerTypeWasChanged = true;
            }
            return {...state, imagineMode: action.imagineMode, ...paxTypeModifierImagine};
        case TYPES.SET_ROUND_TRIP:
            const paxTypeModifier = {};
            const {legs: uFirstLegDatesLegs} = state;
            if (action.roundTrip === 'MULTI') {
                if (uFirstLegDatesLegs[0].dateStart instanceof moment) {
                    uFirstLegDatesLegs[1].dateStart = uFirstLegDatesLegs[0].dateStart.clone().add(1, 'day');
                    uFirstLegDatesLegs[1].dateEnd = uFirstLegDatesLegs[0].dateStart.clone().add(1, 'day');
                }
                if (uFirstLegDatesLegs[0].destination) {
                    uFirstLegDatesLegs[1].origin = {...uFirstLegDatesLegs[0].destination};
                }
                if (state.passengerType !== 'ADULT') {
                    paxTypeModifier.passengerType = 'ADULT';
                    paxTypeModifier.passengerTypeWasChanged = true;
                }
            }
            if (action.roundTrip !== 'RETURN') {
                uFirstLegDatesLegs[0].dateEnd = uFirstLegDatesLegs[0].dateStart instanceof moment ? uFirstLegDatesLegs[0].dateStart.clone() : null;

            } else {
                uFirstLegDatesLegs[0].dateStart = null;
                uFirstLegDatesLegs[0].dateEnd = null;
            }
            legsErrorController(uFirstLegDatesLegs);
            return {...state, roundTrip: action.roundTrip, legs: [...uFirstLegDatesLegs], ...paxTypeModifier};
        case TYPES.SET_DATES:
            const dates = {};
            if (action.dates.hasOwnProperty('start') && action.dates.start) dates.dateStart = action.dates.start;
            if (action.dates.hasOwnProperty('end') && action.dates.end) dates.dateEnd = action.dates.end;
            return {...state, ...dates};
        case TYPES.SET_PASSENGERS:
            return {...state, adultsAmount: action.adults, childrenAmount: action.children, infantsAmount: action.infants};
        case TYPES.SET_PASSENGER_TYPE:
            return {...state, passengerType: action.passengerType};
        case TYPES.SET_PROMO_CODE:
            return {...state, promoCode: action.promoCode};
        case TYPES.ADD_COURSE:
            const {legs: aCourses} = state;
            //const prevIdx = action.course && !isNaN(action.course.idx) ? action.course.idx : aCourses.length - 1;
            if (aCourses.length >= 8) return {...state};
            const modifier = {};
            if (action.course.dateStart && action.course.dateStart instanceof moment) {
                modifier.dateStart = action.course.dateStart.clone();
                modifier.dateEnd = action.course.dateStart.clone();
            }

            if (action.course.destination) modifier.origin = {...action.course.destination};
            const newCourse = { ...action.course, ...COURSE, ...modifier};
            if (action.course && action.course.idx) {
                aCourses.splice(action.course.idx + 1, 0, newCourse)
            } else {
                aCourses.push(newCourse);
            }
            legsErrorController(aCourses);
            return {...state, legs: [...aCourses]};
        case TYPES.REMOVE_COURSE:
            const {legs: rCourses} = state;
            if (rCourses.length <= 2 || !action.course) return {...state};
            rCourses.splice(action.course.idx, 1);
            legsErrorController(rCourses);
            return {...state, legs: [...rCourses]};
        case TYPES.UPDATE_COURSE:
            const {legs: uCourses} = state;
            if (!action.course) return {...state};
            uCourses[action.course.idx] = {...action.course};
            legsErrorController(uCourses);
            const paxTypeModifierDest = {};
            if (action.course.idx === 0
                && uCourses[action.course.idx].origin
                && uCourses[action.course.idx].destination
                && state.passengerType !== 'ADULT') {
                const isOSP = uCourses[action.course.idx].origin.destinationsOSP.includes(uCourses[action.course.idx].destination.code);
                if (!isOSP) {
                    paxTypeModifierDest.passengerType = 'ADULT';
                    paxTypeModifierDest.passengerTypeWasChanged = true;
                }
            }
            return {...state, legs: [...uCourses], ...paxTypeModifierDest};
        case TYPES.SWITCH_COURSES_INDEXES:
            const {legs: sCourses} = state;
            const {idxA, idxB} = action;
            [sCourses[idxA], sCourses[idxB]] = [sCourses[idxB], sCourses[idxA]];
            legsErrorController(sCourses);
            return {...state, legs: [...sCourses]};
        case TYPES.SET_STOPOVER_ELIGIBLE:
            return {
                ...state,
                stopover: {...state.stopover, eligible: action.eligible}
            };
        case TYPES.SET_STOPOVER_ELIGIBLE_CITY_PAIRS:
            return {
                ...state,
                stopover: {...state.stopover, eligibleCityPairs: action.eligibleCityPairs}
            };
        case TYPES.SET_STOPOVER_AVAILABILITY_LOADED:
            return {
                ...state,
                stopover: {...state.stopover, availabilityLoaded: action.availabilityLoaded}
            };
        case TYPES.SET_STOPOVER_OUTGOING:
            return {
                ...state,
                stopover: {...state.stopover, outgoing: {...state.stopover.outgoing, ...action.outgoing}}
            };
        case TYPES.SET_STOPOVER_INCOMING:
            return {
                ...state,
                stopover: {...state.stopover, incoming: {...state.stopover.incoming, ...action.incoming}}
            };
        default:
            return state;
    }
}
